import ToastComponent from '@sdk/common/toast/ToastComponent';

import { Page } from '@web/newsfeed/types/Page';
import { ArticleList } from '@web/newsfeed/Page/ArticleList/ArticleList';
import { useNewsfeedPage } from '@web/newsfeed/Page/NewsfeedPage/newsfeedPage.hooks';

export type Props = {
  page: Page;
};

export const NewsfeedPage = ({ page }: Props) => {
  useNewsfeedPage(page.id, page.articles);

  return (
    <>
      <ArticleList pageId={page.id} />
      <ToastComponent />
    </>
  );
};
